import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    const currentUser = AuthenticationService.getUser();
    const routePermission = route.data['permission'];
    if (currentUser && currentUser.permissions.includes(routePermission)) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
